import { render, staticRenderFns } from "./TeaserSkeletonElement.html?vue&type=template&id=21261e46&"
import script from "./TeaserSkeletonElement.vue?vue&type=script&lang=js&"
export * from "./TeaserSkeletonElement.vue?vue&type=script&lang=js&"
import style0 from "./TeaserSkeletonElement.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports